import { Button, Icon, Tooltip, TooltipContent, TooltipTrigger } from "@qw/ui";
import { PRODUCTION_APP_ORIGINS } from "@/constants/app-origins";

export const OpenInsuredInBrokerageButton = ({ insuredId }: { insuredId: string }) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <Button asChild variant="outline" size="sm" display="icon">
        <a
          href={`${PRODUCTION_APP_ORIGINS.brokerage}/insured/${insuredId}`}
          target="_blank"
          rel="noreferrer"
          aria-label="Open in Brokerage"
        >
          <Icon icon="work" />
        </a>
      </Button>
    </TooltipTrigger>
    <TooltipContent>Open in Brokerage</TooltipContent>
  </Tooltip>
);
